var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 7.33325V4.66659C3.66667 3.78253 4.01786 2.93468 4.64298 2.30956C5.2681 1.68444 6.11595 1.33325 7 1.33325C7.88406 1.33325 8.7319 1.68444 9.35702 2.30956C9.98214 2.93468 10.3333 3.78253 10.3333 4.66659V7.33325M2.33333 7.33325H11.6667C12.403 7.33325 13 7.93021 13 8.66658V13.3333C13 14.0696 12.403 14.6666 11.6667 14.6666H2.33333C1.59695 14.6666 1 14.0696 1 13.3333V8.66658C1 7.93021 1.59695 7.33325 2.33333 7.33325Z",
    stroke: "#725798",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPurple);
export default __webpack_public_path__ + "static/media/lockPurple.f95f9ed0506c77c8c113c24ac6504bbc.svg";
export { ForwardRef as ReactComponent };